'use strict';

angular.module('internal.licenses')
    .controller('InternalTriggerCategoryModal', [
        '$scope',
        '$uibModalInstance',
        'TriggerCategories',
        'TriggerConfigurationTriggers',
        'trigger_configuration_category',
        'trigger_configuration_trigger',
        'trigger_configuration_id',
        'LicenseCategories',
        'licenseID',
        'ProcessEnterprises',
        '$q',
        '$uibModal',
        'MergeTemplates',
        function (
            $scope,
            $uibModalInstance,
            TriggerCategories,
            TriggerConfigurationTriggers,
            trigger_configuration_category,
            trigger_configuration_trigger,
            trigger_configuration_id,
            LicenseCategories,
            licenseID,
            ProcessEnterprises,
            $q,
            $uibModal,
            MergeTemplates) {

        $scope.trigger_category = {
            triggers: []
            };
        $scope.processes = [];
        $scope.license_categories = [];
        $scope.licenseID = licenseID;
        $scope.saving = false;
        $scope.loading = true;
        $scope.parameters = { license_id: $scope.licenseID }
        var promises = [];

        if (trigger_configuration_trigger != null) {
            $scope.trigger_configuration_trigger = trigger_configuration_trigger;
            $scope.trigger_category = trigger_configuration_category;
        }
        else {
            promises.push(TriggerCategories.getByID(trigger_configuration_category.id, (trigger_configuration_category.name == "Approval Process" ? true : false), $scope.licenseID).then(function (category) {
                if (category.no_category_triggers != null) {
                    category.triggers = category.triggers.concat(category.no_category_triggers);
                }

                trigger_configuration_category.trigger_configuration_triggers.forEach(function(trigger) {
                    removeByAttr(category.triggers, 'id', trigger.trigger_id);
                });

                $scope.trigger_category = category;
                $scope.trigger_configuration_trigger = {
                    process_statuses: [],
                    certification_statuses: [],
                    trigger_configuration_id: trigger_configuration_id
                };
            }));
        }
        promises.push(
            LicenseCategories.get().then(function(categories) {
                $scope.license_categories = categories;
            })
        );
        promises.push(
            ProcessEnterprises.get().then(function (processes) {
                $scope.processes = processes;
            })
        );

        promises.push(
            MergeTemplates.get("noIndependentEntities").then(function (mergeTemplates) {
                $scope.mergeTemplates = mergeTemplates;
            })
        );

        $scope.hasStatuses = function (item) {
            return item.certification_statuses.length > 0;
        }

        var isValidCategory = function(category) {
            return (category.user || category.service || category.vehicle) && $scope.hasStatuses(category);
        }

        $q.all(promises).then(function () {
            
            $scope.license_categories = $scope.license_categories.filter(isValidCategory);
            // build up certification_statuses array to include any missing values. It's what we'll use to list out the custom categories in the modal.
            // Using license_categories would make more intuitive sense, but those are static and certification_statuses is what's changing, so we want it bound. Hooray parallel arrays :/
            $scope.license_categories.forEach(function (category) {
                var found = false;
                $scope.trigger_configuration_trigger.certification_statuses.forEach(function(certification_status) {
                    if (certification_status.category_id == category.id) {
                        certification_status.options = category.certification_statuses;
                        found = true;
                    }
                });
                if (!found) {
                    var status = {
                        name: "",
                        category_id: category.id,
                        category_name: category.name,
                        snakecase_category_name: category.name.toLowerCase().replace(" ", "_"),
                        options: category.certification_statuses,
                        note: ""
                    }
                    $scope.trigger_configuration_trigger.certification_statuses.push(status);
                }
            });

            $scope.processes.forEach(function (process) {
                var found = false;
                $scope.trigger_configuration_trigger.process_statuses.forEach(function (process_status) {
                    if (process_status.process_id == process.process.id) {
                        process_status.options = process.process.process_statuses;
                        found = true;
                    }
                });
                if (!found) {
                    var processStatus = {
                        status_id: null,
                        status_name: "",
                        process_id: process.process.id,
                        process_name: process.process.name,
                        process_snakecase_name: process.process.name.toLowerCase().replace(" ", "_"),
                        options: process.process.process_statuses,
                        note: ""
                    }
                    $scope.trigger_configuration_trigger.process_statuses.push(processStatus);
                }
            });

            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

        $scope.$watch('trigger_configuration_trigger.trigger_id', function () {
            if ($scope.trigger_category.triggers) {
                $scope.trigger_category.triggers.forEach(function(trigger) {
                    if (trigger.id == $scope.trigger_configuration_trigger.trigger_id) {
                        $scope.trigger_configuration_trigger.name = trigger.name;
                    }
                });
            }
        });

        $scope.addNoteText = function (id, name, process) {
            var selectObj = document.getElementById(id);
            var note = "";

            var value = selectObj.options[selectObj.selectedIndex].text;
	
            if (value != '') {
                if (process == 0) {
                    note = (name + ' has been changed to ' + value + ($scope.trigger_configuration_trigger.name ? ' by Trigger: ' + $scope.trigger_configuration_trigger.name.replace("'", "") : ""));
                } else {
                    note = (name + ' process has been changed to ' + value + ($scope.trigger_configuration_trigger.name ? ' by Trigger: ' + $scope.trigger_configuration_trigger.name.replace("'", "") : ""));
                }
            }
            return note;
        }

        $scope.save = function () {
            $scope.saving = true;
            TriggerConfigurationTriggers.getActions($scope.trigger_configuration_trigger, [$scope.trigger_configuration_trigger.id], $scope.licenseID).then(function (tct) {
                if (!tct.infiniteFound) {
                    TriggerConfigurationTriggers.save($scope.trigger_configuration_trigger, $scope.licenseID).then(function (newTCT) {
                        TriggerConfigurationTriggers.getByObjectWithActions(newTCT, null, $scope.licenseID).then(function (tctActions) {
                            newTCT = tctActions;
                            $scope.saving = false;
                            $uibModalInstance.close(newTCT);
                        });
                    });
                }
                else {
                    $scope.infiniteFound = true;
                    $scope.saving = false;
                    document.querySelector(".modal").scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }

        $scope.delete = function () {
            $uibModal.open({
                animation: true,
                templateUrl: 'templates/confirm/confirm.html',
                controller: 'ConfirmModalController',
                resolve: {
                    message: function () {
                        return "Are you sure you wish to remove the configuration for this trigger? Note that this is not deleting the trigger itself";
                    }
                }
            }).result.then(function (result) {
                if (result) {
                    $scope.saving = true;
                    TriggerConfigurationTriggers.remove($scope.trigger_configuration_trigger).then(function (deleteResult) {
                        TriggerConfigurationTriggers.getByObjectWithActions(deleteResult).then(function (tctActions) {
                            deleteResult = tctActions;
                            $scope.saving = false;
                            $uibModalInstance.close(deleteResult);
                        });
                    });
                }
            });
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;